module.exports = __webpack_public_path__ + "static/media/Securitas_Logotype_RedNavyBlue_RGB.9bb571c3.svg";